var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Share_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#111213"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.625A3.375 3.375 0 0 0 6.625 13v4A3.375 3.375 0 0 0 10 20.375h9A3.375 3.375 0 0 0 22.375 17v-4a3.366 3.366 0 0 0-1.143-2.532l-.47-.414.828-.937.468.413A4.616 4.616 0 0 1 23.625 13v4A4.625 4.625 0 0 1 19 21.625h-9A4.625 4.625 0 0 1 5.375 17v-4A4.625 4.625 0 0 1 10 8.375h4.625v1.25H10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.625A3.375 3.375 0 0 0 1.625 7v4c0 1.008.441 1.913 1.143 2.532l.47.414-.828.937-.468-.413A4.616 4.616 0 0 1 .375 11V7A4.625 4.625 0 0 1 5 2.375h9A4.625 4.625 0 0 1 18.625 7v4A4.625 4.625 0 0 1 14 15.625H9.375v-1.25H14A3.375 3.375 0 0 0 17.375 11V7A3.375 3.375 0 0 0 14 3.625H5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Share_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 2)",
    d: "M0 0h24v20H0z"
  })))));
};
export default SvgShare;